import { render, staticRenderFns } from "./PartnerOpportunities.vue?vue&type=template&id=3e91b2b8&scoped=true"
import script from "./PartnerOpportunities.vue?vue&type=script&lang=js"
export * from "./PartnerOpportunities.vue?vue&type=script&lang=js"
import style0 from "./PartnerOpportunities.vue?vue&type=style&index=0&id=3e91b2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e91b2b8",
  null
  
)

export default component.exports